import { Component, OnInit, ComponentFactoryResolver } from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { YesNoDataEntity } from 'src/app/models/data-entities';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-yes-no-data-entity-view',
    templateUrl: './yes-no-data-entity-view.component.html',
    styleUrls: ['./yes-no-data-entity-view.component.css'],
    standalone: false
})
export class YesNoDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, context: WorkflowContextService) {
    super(layoutService, componentFactoryResolver, context);
  }
  yesNoEntity: YesNoDataEntity;

  ngOnInit() {
    this.yesNoEntity = <YesNoDataEntity>this.entity;
  }
}
